import template from './parking.jade';
import allItems, { itemsByCategory } from './../../../enums/parking-type';
import { filterItemsWithOrder } from '../../filter-items';

export default angular.module('cian.addForm.parking', []).directive('cianAfAboutBuildingParking', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'categoryService',
    'deviceService',
    function ($scope, categoryService, deviceService) {
      this.isMobile = deviceService.isMobile;

      $scope.$watch(
        () => this.ad.category,
        category => {
          if (!category) {
            return;
          }

          const { objectType } = categoryService.getInfoByCategory(category);
          const categoryConfig = itemsByCategory[objectType] || itemsByCategory.default;

          this.defaultValue = categoryConfig.defaultValue;
          this.items = filterItemsWithOrder(allItems, 'key', categoryConfig.items);

          if (objectType === 'garage') {
            this.name = 'Тип парковки';
          } else {
            this.name = 'Парковка';
          }
        },
      );
    },
  ],
  controllerAs: 'parking',
  template,
})).name;
